// Backlog 205: check every CHECK_MS (and when the tab becomes visible) whether
// the live console names a different main bundle. Read-only GET of index.html,
// no-store; any failure is ignored (an unknown answer never shows the strip).
import { useEffect, useState } from 'react';
import { bundleFromHtml, runningBundle, isNewVersion, CHECK_MS } from '../lib/newVersion';

export function useNewVersion() {
  const [newVersion, setNewVersion] = useState(false);
  useEffect(() => {
    if (typeof document === 'undefined' || import.meta.env.DEV) return undefined;
    const running = runningBundle(document);
    if (!running) return undefined;
    let live = true;
    const check = async () => {
      if (document.visibilityState === 'hidden') return;
      try {
        const res = await fetch('/index.html', { cache: 'no-store' });
        if (!res.ok) return;
        const latest = bundleFromHtml(await res.text());
        if (live && isNewVersion(running, latest)) setNewVersion(true);
      } catch { /* offline or blocked: try again next time */ }
    };
    const t = setInterval(check, CHECK_MS);
    const onVis = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { live = false; clearInterval(t); document.removeEventListener('visibilitychange', onVis); };
  }, []);
  return newVersion;
}
